import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fmtDate } from "../../lib/format";

export default function PostCard({ post, index = 0 }) {
  return (
    <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl">
      <div className="aspect-[16/10] overflow-hidden bg-navy">
        {post.cover_image && <img src={post.cover_image} alt={post.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-center gap-3 text-xs">
          <span className="rounded-full bg-mint/10 px-3 py-1 font-semibold text-mint-600">{post.category}</span>
          <span className="text-slate-400">{fmtDate(post.created_at)}</span>
        </div>
        <h3 className="mt-4 text-lg font-bold leading-snug text-navy">{post.title}</h3>
        <p className="mt-2 line-clamp-3 flex-1 text-sm text-slate-600">{post.excerpt}</p>
        <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-navy">Read article <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5" /></span>
      </div>
    </Link>
  );
}
